import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_VENTA_A_EXPORTADOR } from '../../../../config/tables'

function VentaAExportadoresView () {
  return (
    <MuiTable id={TABLA_VENTA_A_EXPORTADOR} />
  )
}

export default VentaAExportadoresView
